/* Package JSON Import will be here */
import React from "react";
import { VisibilityContext } from "react-horizontal-scrolling-menu";
import { Button } from "antd";
/* Package JSON Import will be here */

/* For Horizontal scroll leftArrow functionality */
export const leftArrow = () => {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext);
    return (
        <div className="btn-left">
            <Button type="button" disabled={isFirstItemVisible} onClick={() => scrollPrev()}
                className="ant-btn ant-btn-primary ant-btn-circle ant-btn-icon-only">
                <i className="fa fa-chevron-circle-left pt-1" aria-hidden="true"></i>
            </Button>
        </div>
    );
}

/* For Horizontal scroll rightArrow functionality */
export const rightArrow = () => {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);
    return (
        <div className="btn-right">
            <Button type="button" disabled={isLastItemVisible} onClick={() => scrollNext()} className="ant-btn ant-btn-primary ant-btn-circle ant-btn-icon-only">
                <i className="fa fa-chevron-circle-right pt-1" aria-hidden="true"></i>
            </Button>
        </div>
    );
}
